import React from 'react';

const ZoomBanner = ({ meetingId, onJoin }) => {
    if (!meetingId) {
        return null;
    }

    return (
        <div className="discussion-zoom-banner">
            There's an ongoing Zoom Meeting.

            <button className="btn btn-secondary btn-small" onClick={onJoin}>Join Meeting</button>
        </div>
    )
}

export default ZoomBanner;
